<script lang="ts" setup>
  import type { ProductVariantResource } from '@storefront/resources';
  import ShopProductViewComponent from './ShopProductViewComponent.vue';

  interface Props {
    variant: ProductVariantResource,
  }

  defineProps<Props>();
</script>
<template>
  <div v-if="variant.components.length > 0" class="components">
    <h2 class="components-title">{{ $t('SHOP.PRODUCT.HEADER.SET_CONTAINS')}}</h2>
    <div class="components-list">
      <ShopProductViewComponent v-for="component in variant.components" :component />
    </div>
  </div>
</template>
<style lang="scss">
  @use '@storefront/styles/mixins/media';

  :root {
    --sf-shop-product-components-gap: 1rem;
    --sf-shop-product-components-title-font-size: 0.875rem;

    @include media.query(lg) {
      --sf-shop-product-components-gap: 0.5rem;
    }
  }

  .components {
    display: flex;
    flex-direction: column;
    gap: var(--sf-shop-product-components-gap);

    .components-title {
      font-size: var(--sf-shop-product-components-title-font-size);
    }
  }
</style>
